import { attributesStyles } from "@WhiteCap/Widgets/ProductDetailsPage/ProductDetailsSpecification";
import { css } from "styled-components";

/*

**** EC-231 Product Details Page (PDP) ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
attributesStyles.specificationTittle = {
    css: css`
        border-bottom: 0.2rem solid #fc3;
        box-sizing: border-box;
        display: inline-flex;
        font-weight: 500;
        color: rgb(71, 71, 71);
        font-size: 16px;
        text-transform: uppercase;
        margin-bottom: 20px;
        padding-top: 10px;
    `,
};
// EC-617 : Fixing css issues on PLP & PDP
attributesStyles.descriptionAccordion = {
    css: css`
        margin-bottom: 20px;
        border-top: 1px solid #ccc;
        padding-top: 10px;
    `,
};

/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS. */
